module.exports = __webpack_public_path__ + "img/preview-1.caf22409.png";